import { render } from "./KeFu.vue?vue&type=template&id=e5c42b64&scoped=true"
import script from "./KeFu.vue?vue&type=script&lang=js"
export * from "./KeFu.vue?vue&type=script&lang=js"

import "./KeFu.vue?vue&type=style&index=0&id=e5c42b64&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c42b64"]])

export default __exports__